const unauthenticated = {
  root: '/',
  signIn: '/signin',
  logIn: '/login',
  phoneReset: '/phone/resets',
  billSettlement: '/s/:paidyCode',
  bill: '/s/:paidyCode/bill',
};

const authenticated = {
  home: {
    root: '/home',
    billSummary: '/home/bill-summary',
    billDetails: '/home/bill-summary/:id',
    billSettlement: '/home/bill-settlement/:id',
    billSettlementMethod: '/home/bill-settlement/:id/:method',
    billSettlementBankTransfer: '/home/bill-settlement/:id/transfer',
  },
  usage: {
    root: '/usage',
    plusContracts: '/usage/plus-contracts',
    plusContractDetail: '/usage/plus-contracts/:id',
    multiPayContracts: '/usage/multipay-contracts',
    multiPayContractDetail: '/usage/multipay-contracts/:id',
    contractsSummary: '/usage/contracts-summary',
  },
  account: {
    root: '/account',
  },
  ekyc: {
    root: '/ekyc',
    apply: '/ekyc/apply',
  },
};

const common = {
  // These routes are used by the mobile app
  apple: {
    root: '/apple',
    feature: '/apple-feature',
  },
  shopping: {
    browse: '/browse',
    inspiration: '/inspiration',
  },
  paidyCard: {
    onboarding: 'paidy-link-onboarding',
    paypal: 'promote-paypal',
    paypalLink: '/links/paypal',
  },
  nlp: {
    monthlyPowerReset: 'monthly-power-reset',
    repacOnboarding: 'repac-onboarding',
    nlpIntro: 'nlp-intro',
  },
  deepLink: {
    repac: 'repac',
  },
  externalRedirect: '/external-redirect',
  // For impersonation
  impersonate: '/impersonate',
  // 404
  notFound: '*',
};

export default {
  unauthenticated,
  authenticated,
  common,
};
